import { PlusIcon } from "@heroicons/react/24/solid";

import { Button, Paragraph, Small } from "@fronterahealth/frontera-ui-components";

import { ReportSectionFieldTypeEnums } from "@api/graphql/types-and-hooks";
import { AddRecommendationsBank } from "@components/RecommendationsBank/AddRecommendationsBank/AddRecommendationsBank";
import { getFieldTypeByContent } from "@components/SectionWidget/SectionWidget";
import { useAdminData } from "@providers/AdminDataProvider";
import { useReport } from "@providers/ReportProvider";

interface AddRecommendationsPanelProps {
  sectionId: string;
  onAddContent: (fieldType: ReportSectionFieldTypeEnums, rankOrder: number) => Promise<unknown>;
  newRankOrder: number;
  displayNoContentMessage?: boolean;
}

export const AddRecommendationsPanel: React.FC<AddRecommendationsPanelProps> = ({
  sectionId,
  onAddContent,
  newRankOrder,
  displayNoContentMessage = false,
}) => {
  const { reportQuery } = useReport();
  const { isCatalightUser } = useAdminData();

  const handleAddContent = async () => {
    const fieldType = getFieldTypeByContent("Text");
    if (fieldType) {
      await onAddContent(fieldType, newRankOrder);
    }
  };

  return (
    <div className="flex justify-center">
      <div className="w-full pr-6 mt-4">
        {displayNoContentMessage ? (
          <div className="rounded-md mt-2 mb-4 py-4 w-full bg-background-secondary">
            <div className="flex justify-center w-full mb-2">
              <Paragraph displayType="loud">You have no recommendations added</Paragraph>
            </div>
            <div className="flex justify-center w-full">
              <Paragraph displayType="normal">You must have at least one recommendation selected to continue</Paragraph>
            </div>
          </div>
        ) : null}
        {isCatalightUser ? (
          <></>
        ) : (
          <div className="flex justify-end w-full space-x-2">
            <AddRecommendationsBank
              sectionId={sectionId}
              onAdd={async () => {
                await reportQuery.refetch();
              }}
              newRankOrder={newRankOrder}
            />
            <Button
              text={
                <Small className={"flex items-center px-2 text-white"}>
                  <PlusIcon className="mr-2 h-4 w-4" />
                  Custom Recommendation
                </Small>
              }
              buttonAction="action"
              appearance={"primary"}
              onClick={() => handleAddContent()}
            />
          </div>
        )}
      </div>
    </div>
  );
};
